module.exports = __webpack_public_path__ + "static/media/loading.fd447e2f.gif";